import { __assign } from "tslib";
/* eslint-disable import/no-unused-modules,prettier/prettier */
import React, { forwardRef } from 'react';
import { SvgIcon } from '../SvgIcon';
export var CircleFilled = forwardRef(function (props, ref) { return (React.createElement(SvgIcon, __assign({ ref: ref }, props, { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("circle", { cx: "8", cy: "8", r: "3", fill: "currentColor" }))); });
CircleFilled.displayName = 'CircleFilled';
//# sourceMappingURL=CircleFilled.js.map